export const ACTIVITY_DETAIL_MAP_STYLES = {
  street: 'mapbox://styles/mapbox/outdoors-v12',
  satellite: 'mapbox://styles/mapbox/satellite-v9',
};
